__turbopack_context__.v({
  "chevronExpanded": "FZ_eDa_chevronExpanded",
  "chevronIcon": "FZ_eDa_chevronIcon",
  "content": "FZ_eDa_content",
  "delimiter": "FZ_eDa_delimiter",
  "headerButton": "FZ_eDa_headerButton",
  "headerContent": "FZ_eDa_headerContent",
  "headerText": "FZ_eDa_headerText",
  "plusIcon": "FZ_eDa_plusIcon",
  "root": "FZ_eDa_root",
});
